import { Routes } from "@angular/router"
import { MsalGuard } from "@azure/msal-angular"
import {
    AwardsService,
    BenefitsService,
    NewsService,
    PerksService,
    PromotionalContentService,
    SurveyService,
} from "./services"
import {
    BenefitsTablePage,
    BenefitsAddPage,
    BenefitsEditPage,
    NavigationPage,
    BenefitLayoutPage,
    AwardsTablePage,
    AwardsAddPage,
    AwardsEditPage,
    PerksTablePage,
    PerksAddPage,
    PerksEditPage,
    CategoriesTablePage,
    CategoriesAddPage,
    CategoriesEditPage,
    NewsTablePage,
    NewsAddPage,
    NewsEditPage,
    SurveysTablePage,
    SurveysAddPage,
    SurveysEditPage,
    PromotionalContentTablePage,
    PromotionalContentAddPage,
    PromotionalContentEditPage,
    LocationsTablePage,
    LocationsAddPage,
    LocationsEditPage,
    VdkPage,
    KngPage,
    KngSubmittedPage,
    AverageMonthlyIncomePage,
    PositionScoresPage,
    KngCommissionPage,
    KngInProgressPage,
    KngApprovedPage,
    KngGeneratePage,
    KngContractGeneratePage,
    KngUploadContractsPage,
} from "./pages"

export const routes: Routes = [
    {
        path: "",
        redirectTo: "surveys",
        pathMatch: "full",
    },
    {
        path: "",
        component: NavigationPage,
        canActivate: [MsalGuard],
        canActivateChild: [MsalGuard],
        children: [
            {
                path: "news",
                component: BenefitLayoutPage,
                providers: [NewsService],
                children: [
                    { path: "", component: NewsTablePage, data: { view: "table" } },
                    { path: "add", component: NewsAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: NewsEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "benefits",
                component: BenefitLayoutPage,
                providers: [BenefitsService],
                children: [
                    { path: "", component: BenefitsTablePage, data: { view: "table" } },
                    { path: "add", component: BenefitsAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: BenefitsEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "awards",
                component: BenefitLayoutPage,
                providers: [AwardsService],
                children: [
                    { path: "", component: AwardsTablePage, data: { view: "table" } },
                    { path: "add", component: AwardsAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: AwardsEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "perks",
                component: BenefitLayoutPage,
                providers: [PerksService],
                children: [
                    { path: "", component: PerksTablePage, data: { view: "table" } },
                    { path: "add", component: PerksAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: PerksEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "categories",
                component: BenefitLayoutPage,
                children: [
                    { path: "", component: CategoriesTablePage, data: { view: "table" } },
                    { path: "add", component: CategoriesAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: CategoriesEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "surveys",
                component: BenefitLayoutPage,
                providers: [SurveyService],
                children: [
                    { path: "", component: SurveysTablePage, data: { view: "table" } },
                    { path: "add", component: SurveysAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: SurveysEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "promotional-content",
                component: BenefitLayoutPage,
                providers: [PromotionalContentService],
                children: [
                    { path: "", component: PromotionalContentTablePage, data: { view: "table" } },
                    { path: "add", component: PromotionalContentAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: PromotionalContentEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "locations",
                component: BenefitLayoutPage,
                children: [
                    { path: "", component: LocationsTablePage, data: { view: "table" } },
                    { path: "add", component: LocationsAddPage, data: { view: "add" } },
                    { path: "edit/:masterId", component: LocationsEditPage, data: { view: "edit" } },
                ],
            },
            {
                path: "vdk",
                component: VdkPage,
            },
            {
                path: "kng",
                component: KngPage,
            },
            {
                path: "kng-in-progress",
                component: KngInProgressPage,
            },
            {
                path: "kng-approved",
                component: KngApprovedPage,
            },
            {
                path: "kng-contract-generate",
                component: KngContractGeneratePage,
            },
            {
                path: "kng-generate",
                component: KngGeneratePage,
            },
            {
                path: "kng-upload-contracts",
                component: KngUploadContractsPage,
            },
            {
                path: "kng-submitted",
                component: KngSubmittedPage,
            },
            {
                path: "kng-commission",
                component: KngCommissionPage,
            },
            {
                path: "average-monthly-income",
                component: AverageMonthlyIncomePage,
            },
            {
                path: "kng-position-scores",
                component: PositionScoresPage,
            },
        ],
    },
    {
        path: "**",
        redirectTo: "surveys",
        pathMatch: "full",
    },
]

